import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button, Input, Row } from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import Swal from "sweetalert2";

import commentApi from "../../../apis/Comment.api";
import { toastAlert } from "../../AlertComponent";

import CommentFavorite from "./CommentFavorite";
import CommentImagePreviewGroup from "./CommentImagePreviewGroup";
import CommentImageSlideGroup from "./CommentImageSlideGroup";
import CommentImageUpload from "./CommentImageUpload";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const CommentReplyEach = ({
	reply,
	index,
	idx,
	replyShow,
	setReplyShow,
	replyIdx,
	setReplyIdx,
	comLoading,
	setComLoading,
	getCommentList,
	// findComment,
	setFindComment,
	currentPageNumber,
}) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	// const [popoverOpen, setPopoverOpen] = useState(false);
	// const [popoverId, setPopoverId] = useState(null);

	const [isCommentSet, setIsCommentSet] = useState(false);
	const [selectComment, setSelectComment] = useState({});

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);
	const [biggestTitle, setBiggestTitle] = useState(0);

	useEffect(() => {
		setIsCommentSet(false);
		setSelectComment({});
		setReplyShow(false);
	}, [currentPageNumber]);

	useEffect(() => {
		// 댓글 이미지 리스트
		if (reply?.imageList?.length > 0) {
			// 타이틀 중 가장 큰 값 저장
			let bigTitle =
				reply?.imageList
					?.reduce((prev, value) => {
						return prev?.title?.split("-")?.[1] >= value?.title?.split("-")?.[1]
							? prev
							: value;
					})
					?.title?.split("-")?.[1] ?? 0;
			setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

			let list = [];
			let photos = [];
			for (let i = 0; i < reply?.imageList?.length; i++) {
				let resultImageList = reply?.imageList[i];
				let source = `${process.env.REACT_APP_S3_HOST}/image/together/reply/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
				list.push(source);
				photos.push({
					title: resultImageList?.title,
					source: source,
					type: `image/${resultImageList?.img_type}`,
				});
			}
			// 최대 1개까지
			setImageList(list.slice(0, 1));
			setPhotoList(photos.slice(0, 1));
		} else {
			setImageList([]);
			setPhotoList([]);
		}
	}, [reply]);

	/**
	 * 이미지 삭제 (목록에서 제거 -> 작성/수정완료 클릭 시 적용)
	 * @param idx
	 */
	const onDeleteImage = (idx) => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				let list = [...imageList];
				let photos = [...photoList];
				list.splice(idx, 1);
				photos.splice(idx, 1);
				setImageList(list);
				setPhotoList(photos);
			}
		});
	};

	/**
	 * popover click
	 * @param id
	 */
	// const handlePopover = (id) => {
	//     setPopoverId(id);
	//     setPopoverOpen(true);
	// }

	// useEffect(() => {
	//     if (replyIdx !== null) {
	//         handleShowCommentReply(index, idx);
	//     }
	// }, [replyIdx])

	/**
	 * 답글 보여주기
	 * @param index
	 */
	const handleShowCommentReply = (index, idx) => {
		if (replyShow) {
			if (replyIdx === idx) {
				setReplyShow(false);
				setReplyIdx(idx);
			}
		} else {
			setReplyShow(true);
			setReplyIdx(idx);
		}
		// if (replyIdx !== idx) {
		//     setReplyShow(true);
		//     setReplyIdx(idx);
		// } else {
		//     if (replyShow) {
		//         setReplyShow(false);
		//     } else {
		//         setReplyShow(true)
		//     }
		// }
	};

	/**
	 * 답글 수정
	 * @returns {Promise<void>}
	 */
	const onUpdateReply = async () => {
		if (selectComment?.content?.trim()?.length) {
			setComLoading(true);
			const param = {
				...selectComment,
				updated_by: cUser?.id,
				is_influencer: !!cUser?.is_influencer,
			};
			const res = await commentApi.adminUpdateReply(param);
			if (res.code === 200) {
				updateImageList(param);
			}
			setComLoading(false);
		} else {
			toastAlert("답글을 작성해주세요.");
		}
	};
	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const updateImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			// 등록
			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
			// 수정
			else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		const param = {
			target_id: result?.id,
			target_type: "reply",
			created_by: cUser?.id,
			imageList: [...list],
		};
		const res = await commentApi.postCommentImage(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "정상적으로 수정이 완료되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				getCommentList();
				setSelectComment({});
				setIsCommentSet(false);
				setImageList([]);
				setPhotoList([]);
				setFindComment(false);
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("reply-image-list-error");
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/reply/${reduxChannel?.user_id}/${result?.id}-${
			biggestTitle + i + 1
		}.${fileType}`;
		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("reply-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("reply-s3-upload-error");
				setComLoading(false);
			});
		}
	};

	/**
	 * 수정 취소
	 * @returns {Promise<void>}
	 */
	const onUpdateCancelReply = async () => {
		if (selectComment?.content !== reply?.content) {
			Swal.fire({
				customClass: "alert-custom",
				text: `수정 중인 내용이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setSelectComment({});
					setIsCommentSet(false);
				}
			});
		} else {
			setSelectComment({});
			setIsCommentSet(false);
		}
	};

	/**
	 * 답글 삭제
	 * @returns {Promise<void>}
	 */
	const onDeleteReply = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 댓글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setComLoading(true);
				const param = {
					replyId: reply.id,
					userId: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				const res = await commentApi.deleteReply(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						getCommentList();
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						getCommentList();
					});
				}
				setComLoading(false);
			}
		});
	};

	return (
		<>
			<img
				src={`/assets/images/channel/comment-reply.png`}
				alt={`댓글 프로필 이미지`}
				className={`comment-reply-img`}
			/>
			<div className={`comment-each`}>
				<div className={`comment-user-div`}>
					<img
						src={`${
							reply?.is_influencer
								? `${process.env.REACT_APP_S3_HOST}/image/together/profile_${reply?.created_by}.${reply?.influencer_profile_img_type}`
								: reply?.profile_img_type
								? `${process.env.REACT_APP_S3_HOST}/image/together/channel_user/profile/${reply?.created_by}.${reply?.profile_img_type}`
								: `/assets/images/channel/basic.png`
						}`}
						alt={`댓글 프로필 이미지`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							// currentTarget.style.display = "none";
							currentTarget.src = `/assets/images/channel/basic.png`;
						}}
						className={`comment-img`}
					/>
					<Row align={"middle"}>
						{reply?.is_influencer ? (
							<>
								{reply?.created_by === reduxChannel?.user_id ? (
									<p className={`user-phone influencer`}>
										{reply?.created_by_name}
									</p>
								) : (
									<p className={`user-phone`}>{reply?.created_by_name}</p>
								)}
							</>
						) : (
							<p className={`user-phone`}>
								{reply?.created_by_name ? reply?.created_by_name : reply?.phone}
							</p>
						)}

						<p className={`gray`}>ㆍ</p>
						<p className={`gray`}>
							{moment(moment(reply?.created_at), "YYYY.MM.DD").fromNow()}
						</p>
						{reply?.is_secret && (
							<>
								<p className={`gray`}>ㆍ</p>
								<img
									src={`/assets/images/channel/secret.png`}
									alt={`비밀댓글`}
									style={{
										height: "0.9em",
										width: "0.9em",
									}}
								/>
							</>
						)}
					</Row>

					<CommentFavorite item={reply} type={"reply"} />
				</div>

				{/* 답글 수정 */}
				{!!isCommentSet && !!selectComment?.id ? (
					<div className={`update-comment-input`}>
						<Input.TextArea
							type={"text"}
							value={selectComment?.content}
							onChange={(e) => {
								setSelectComment({
									...selectComment,
									content: e.target.value,
								});
							}}
							disabled={comLoading}
						/>

						{/* 업로드한 이미지 보기 */}
						{!!imageList?.length && (
							<CommentImagePreviewGroup
								imageList={imageList}
								onDeleteImage={onDeleteImage}
								loading={comLoading}
							/>
						)}

						<div className={`comment-input-button-group`}>
							{/* 댓글 이미지 업로드 */}
							<CommentImageUpload
								imageList={imageList}
								setImageList={setImageList}
								photoList={photoList}
								setPhotoList={setPhotoList}
							/>
							<div
								className={`is_secret`}
								onClick={() => {
									if (!comLoading) {
										setSelectComment({
											...selectComment,
											is_secret: !selectComment.is_secret,
										});
									}
								}}
								style={{
									marginRight: "auto",
									marginLeft: 0,
								}}
							>
								<img
									src={`/assets/images/login/check${
										selectComment.is_secret ? "-active" : ""
									}.png`}
									alt={`비밀글`}
									style={{
										height: "100%",
										width: "1em",
									}}
								/>
								비밀글
							</div>

							<Button
								size={`small`}
								className={`black`}
								onClick={onUpdateReply}
								disabled={comLoading}
							>
								수정
							</Button>
							<Button
								size={`small`}
								onClick={onUpdateCancelReply}
								disabled={comLoading}
							>
								취소
							</Button>
						</div>
						<p
							style={{
								fontSize: "0.9em",
								color: "#6d7580",
								letterSpacing: "-0.5px",
							}}
						>
							* 이미지는 최대 1장까지 가능합니다.
						</p>
					</div>
				) : (
					<>
						{reply?.is_secret ? (
							<>
								{reply?.content?.length ? (
									<>
										{!!reply?.imageList?.length && (
											<CommentImageSlideGroup
												imageList={reply?.imageList}
												type={"reply"}
											/>
										)}
										<p className={`comment-content`}>{reply?.content}</p>
									</>
								) : (
									<p className={`comment-content secret`}>비밀 댓글입니다</p>
								)}
							</>
						) : (
							<>
								{!!reply?.imageList?.length && (
									<CommentImageSlideGroup
										imageList={reply?.imageList}
										type={"reply"}
									/>
								)}
								<p className={`comment-content`}>{reply?.content}</p>
							</>
						)}
					</>
				)}
				{!isCommentSet && !selectComment?.id ? (
					<div className={`comment-footer`}>
						<p className={`comment-date`}>
							{moment(reply.created_at).format("YYYY.MM.DD a hh:mm")}
						</p>
						<button
							className={`comment-reply`}
							onClick={() => {
								setReplyIdx(idx);
								handleShowCommentReply(index, idx);
							}}
							disabled={comLoading}
						>
							답글쓰기
						</button>
						{((!reply?.is_influencer && reply?.created_by === cUser?.id) ||
							(cUser?.is_influencer && reply?.created_by === cUser?.id)) && (
							<>
								<button
									className={`comment-date`}
									onClick={() => {
										setSelectComment(reply);
										setIsCommentSet(true);
									}}
									disabled={comLoading}
								>
									수정
								</button>
								<button
									className={`comment-date`}
									onClick={onDeleteReply}
									disabled={comLoading}
								>
									삭제
								</button>
							</>
						)}
					</div>
				) : (
					<></>
				)}
			</div>
		</>
	);
};
export default CommentReplyEach;
